import { IMessageBarProps, MessageBar, MessageBarType } from "@fluentui/react";
import React from "react";

import { Stack } from "../layouts/stack/Stack";
import { Text } from "./Text";

export interface InfoMessageProps extends Pick<IMessageBarProps, "children" | "styles"> {
    message?: string;
}

export const InfoMessage: React.FunctionComponent<InfoMessageProps> = (props: InfoMessageProps) => {
    return (
        <Stack>
            <MessageBar messageBarType={MessageBarType.info} isMultiline={true}>
                <Text block={false} nowrap={false} variant="smallPlus">
                    {props.message}
                </Text>
            </MessageBar>
        </Stack>
    );
};
